import { Stack, ViewHeader, ViewItemField } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  fullName: string;
  email: string;
  branchName?: string;
  branchCode?: string;
  billableFromLabel: string;
  createdAtLabel: string;
  updatedAtLabel: string;
  editLink: string;
};

/**
 * 利用者詳細プロフィールの Presentation コンポーネント
 * 利用者名・編集ボタン・各種データ行を表示する
 */
export const UserDetailProfilePresentation: React.FC<Props> = ({
  fullName,
  email,
  branchName,
  branchCode,
  billableFromLabel,
  createdAtLabel,
  updatedAtLabel,
  editLink,
}) => (
  <div className={styles.container}>
    <ViewHeader title={fullName} editLink={editLink} />
    <Stack direction='column' gap={24}>
      <ViewItemField label='メールアドレス' direction='row' value={email} />
      {branchName && <ViewItemField label='事業所' direction='row' value={branchName} />}
      {branchCode && <ViewItemField label='事業所コード' direction='row' value={branchCode} />}
      <ViewItemField label='利用開始日' direction='row' value={billableFromLabel} />
      <ViewItemField label='作成日時' direction='row' value={createdAtLabel} />
      <ViewItemField label='更新日時' direction='row' value={updatedAtLabel} />
    </Stack>
  </div>
);
